import { useRef } from 'react';
import { judgType } from '../TransferPerson/dataTransfer';

// 将选好的数据转换为JSON数据
export const transferSelectedDataToJson = (selectedList) => {
  const resultJsonData = [];
  selectedList.forEach((item) => {
    resultJsonData.push({
      Type: judgType(item.leafType, false),
      Name: `${item.title}`,
      Account: `${item.key}` || '',
      PhoneNum: item.PhoneNum ? `${item.PhoneNum}` : '',
    });
  });
  return resultJsonData;
};

export function debounce(fn, wait) {
  let timmer, context;
  return function (...args) {
    context = this;
    if (timmer) clearTimeout(timmer);
    timmer = setTimeout(function () {
      timmer = null;
      fn.apply(context, args);
    }, wait);
  };
}

export function useDebounceFn(func, wait, immediate) {
  let timeout = useRef(),
    context,
    result;
  function resDebounced(...args) {
    // 这个函数里面的this就是要防抖函数要的this
    // args就是事件对象event
    context = this;

    // 一直触发一直清除上一个打开的延时器
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    };

    if (immediate) {
      // 第一次触发，timeout===undefined恰好可以利用timeout的值
      const callNow = !timeout.current;
      (timeout.current as any) = setTimeout(function () {
        timeout.current = null;
      }, wait);
      if (callNow) result = func.apply(context, args);
    } else {
      // 停止触发，只有最后一个延时器被保留
      (timeout.current as any) = setTimeout(function () {
        timeout.current = null;
        // func绑定this和事件对象event，还差一个函数返回值
        result = func.apply(context, args);
      }, wait);
    }
    return result;
  }
  resDebounced.cancal = function () {
    clearTimeout(timeout.current);
    timeout.current = null;
  };
  return resDebounced;
}
